import { RELEASE_APRIL_TAX_SERVICES } from '#client/constants/experimentsFlags';

import { TaxClassificationGate } from '../components/gates/TaxClassificationGate';
import { BUSINESS_ENTITY_TAX_CLASSIFICATION } from '../utils/taxClassification';
import { getTaxFilingBuyButtonConfig } from '../utils/taxEntitlements';

export const TAX_FILING_CONFIG = {
  hero: {
    headline: 'productPage.taxFiling.page.headline',
    subheader: 'productPage.taxFiling.page.subheader',
    headerPicture: {
      src: '/s2/raster/happy-woman-using-calculator.png',
      alt: 'productPage.taxFiling.heroPicture.altText'
    },
    partnerLogo: {
      src: '/s2/vector/april-logo-purple.svg',
      alt: 'productPage.taxFiling.partnerLogo.altText'
    },
    partnerReviewBlanks: [
      {
        text: 'productPage.taxFiling.partnerReviewBlanks.trustpilot.reviewText'
      },
      {
        src: '/illustration/trustpilot-4.5-star.svg',
        showOnMobile: true,
        alt: 'productPage.taxFiling.partnerReviewBlanks.trustpilot.reviewStarAltText'
      },
      {
        src: '/illustration/trustpilot-logo.svg',
        alt: 'productPage.taxFiling.partnerReviewBlanks.trustpilot.reviewLogoAltText'
      }
    ],
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.taxFiling.buyBox.bulletPoint1' },
        { title: 'productPage.taxFiling.buyBox.bulletPoint2' },
        { title: 'productPage.taxFiling.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.taxFiling.buyBox.productName',
      interactService: {
        ctaType: 'internalCheckout',
        service: 'zb_tax_full_service_biz_per_llc',
        interval: 'annual'
      }
    }]
  },
  benefit: {
    title: 'productPage.taxFiling.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/checklist.svg',
        title: 'productPage.taxFiling.valueProp.propTitle1',
        description: 'productPage.taxFiling.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/calculaterounded.svg',
        title: 'productPage.taxFiling.valueProp.propTitle2',
        description: 'productPage.taxFiling.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/tableviewrounded.svg',
        title: 'productPage.taxFiling.valueProp.propTitle3',
        description: 'productPage.taxFiling.valueProp.shortCopy3'
      }
    ]
  },
  howItWorks: {
    title: 'productPage.taxFiling.howItWorks.title',
    items: [
      {
        title: 'productPage.taxFiling.howItWorks.step1',
        description: 'productPage.taxFiling.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.taxFiling.howItWorks.step2',
        description: 'productPage.taxFiling.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.taxFiling.howItWorks.step3',
        description: 'productPage.taxFiling.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/barista-smiling-watch.png',
    alt: 'productPage.taxFiling.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  whatsIncluded: {
    title: 'productPage.taxFiling.whatsIncluded.title',
    items: [
      {
        title: 'productPage.taxFiling.whatsIncluded.item1',
        description: 'productPage.taxFiling.whatsIncluded.item1.descriptionItems'
      },
      {
        title: 'productPage.taxFiling.whatsIncluded.item2',
        description: 'productPage.taxFiling.whatsIncluded.item2.descriptionItems'
      }
    ],
    image: '/s2/raster/tax-filing-process.png',
    alt: 'productPage.taxFiling.whatsIncluded.altText',
    hasIcon: true,
    hasDivider: false,
    hasNumber: false,
    hasMobileImage: false
  },
  relatedProducts: {
    title: 'productPage.taxFiling.relatedProducts.title',
    items: [
      {
        title: 'productPage.taxFiling.relatedProducts.quarterlyTaxPlanning.title',
        description: 'productPage.taxFiling.relatedProducts.quarterlyTaxPlanning.description',
        productSlug: 'quarterly-tax-planning',
        entitlement: 'zb_quarterly_tax_planning'
      },
      {
        title: 'dashboard.products.money_pro.title',
        description: 'dashboard.products.money_pro.description',
        productSlug: 'money-pro',
        entitlement: 'money_pro'
      }
    ]
  },
  footnotes: [
    {
      id: '*',
      text: 'productPage.taxFiling.footnotes.1.text',
      link: 'https://higherlogicdownload.s3.amazonaws.com/NSACCT/725010a8-142f-4092-8b5d-077c2618c728/UploadedImages/Membership/IncomeandFeeSurvey/NSA2020-2021_IncomeandFeesStudy_NationalAverages.pdf'
    }
  ],
  assistance: {
    title: 'productPage.taxFiling.needAssistance.title',
    getInTouch: 'productPage.taxFiling.needAssistance.getInTouch',
    actions: 'productPage.taxFiling.needAssistance.actions'
  },
  // Configure product gates (feature flags, component with custom logic, etc.) useful for conditional redirects
  productGates: {
    flagGate: {
      flagKey: RELEASE_APRIL_TAX_SERVICES,
      redirectPath: '/products/tax-advice'
    },
    componentGate: {
      Component: TaxClassificationGate,
      props: {
        shouldRedirect: (taxClassification) => taxClassification
          !== BUSINESS_ENTITY_TAX_CLASSIFICATION.SINGLE_MEMBER_LLC,
        redirectPath: '/products/tax-advice'
      }
    }
  },
  getBuyButtonConfig: getTaxFilingBuyButtonConfig
};
